import GeneralHead from "@logics/tags/GeneralHead";
import { loadPropsWithLocale } from "@logics/utils/i18n";
import Meta from "@domains/landing/views/Meta/Meta";
import StackLayout from "@domains/common/views/layouts/StackLayout/StackLayout";

const MetaLandingPage = () => {
  return (
    <>
      <GeneralHead />

      <StackLayout hideNavbar>
        <Meta />
      </StackLayout>
    </>
  );
};

export default MetaLandingPage;

export const getStaticProps = loadPropsWithLocale();
